module.exports = new __parcel__URL__("shop_item_info_stardust_progress_bar.d4d72b2f.png").toString();